// FIXME: no persian words in code

export enum UsersTypeEnum {
  STUDENT = 1, // دانش آموز
  TEACHER = 9, // دبیر
  ADVISOR = 2, // مشاور
  DEAN = 4, // مدرسه
  آموزشگاه = 20, // آموزشگاه
  مرکز_مشاوره = 21, // مرکز مشاوره
  ADMINISTRATOR = 3, // ادمین
  OPERATOR = 5, // اپراتور
  AUTHOR = 6, // نویسنده
  OBSERVER = 7, // ناظر
  AGENT = 8, // مسئول
  SALES_MANAGER = 10, // مدیر فروش
  SALES_EXPERT = 11, // کارشناس فروش
  PARENT = 12, // والد
  SCHOOLOPERATOR = 13, // اپراتور مدرسه
  PRESENTER = 14, // نیروی صف
  AM = 22, // مدير اکانت
  SDR = 23, // کارشناس توسعه فروش
  مدیر_مالی = 24, // مدیر مالی
  کارشناس_مالی = 25, // کارشناس مالی
  SUPER_USER = 26, // مجتمع
  PUBLISHER = 27, // انتشارات
  معاون_مدرسه = 28, // معاون مدرسه
  MARKETING_MANAGER = 29, // مدیر بازاریابی
  MARKETING = 30, // بازاریابی
}
